import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BuildingAddressDirective } from '@cfp/shared/building/address-module';
import { EnergyLabel } from '@cfp/shared/energy-label';
import { StreetViewImageComponent } from '@cfp/shared/ui/street-view-image';
import { Badge, CurrencyModule, Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  CurrencyCodeDTO,
  LabelGroupDTO,
  OwnershipStatusDTO,
  PortfolioBuildingsRoadmapBuildingDTO,
  PortfolioBuildingsRoadmapDTOTotalInvestmentPerYear
} from 'csr-asset-app';

@Component({
  selector: 'cfp-report-portfolio-roadmap-table',
  templateUrl: 'report-portfolio-roadmap-table.html',
  styleUrls: ['report-portfolio-roadmap-table.scss'],
  imports: [
    EnergyLabel,
    Icon,
    StreetViewImageComponent,
    BuildingAddressDirective,
    TranslateModule,
    CurrencyModule,
    Badge
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportPortfolioRoadmapTable {
  protected readonly OwnershipStatusDTO = OwnershipStatusDTO;

  public readonly buildingsWithPlan = input.required<PortfolioBuildingsRoadmapBuildingDTO[]>();
  public readonly showProperty = input.required<'energyLabel' | 'investment'>();
  public readonly years = input.required<string[]>();
  public readonly currencyCode = input.required<CurrencyCodeDTO>();
  public readonly totalInvestments = input<PortfolioBuildingsRoadmapDTOTotalInvestmentPerYear[]>();
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');

  protected readonly labelGroup = LabelGroupDTO.EPC;

  protected readonly numberOfColumns = computed(() => {
    let numberOfColumns = this.years().length + 1;
    if (this.showProperty() === 'investment') {
      numberOfColumns++;
    }
    return numberOfColumns;
  });

  protected translationKey(suffix: string): string {
    return `${this.translationKeyPrefix()}.${suffix}`;
  }
}
